import router from "../router";

/**
 * Iterates over all the provided filters and returns a query object with all those that are not empty ('' or null').
 * This is a query to be used with the vue router.
 *
 * @param filters
 * @returns {{}}
 */
export function filtersToQueryParameters(filters) {
    let query = {};

    for (let index in filters) {
        if (filters[index] !== '' && filters[index] !== null) {
            query[index] = filters[index];
        }
    }

    return query;
}

/**
 * Loads the provided route_name with the provided filters. If the same route as user is in, filters are set in the url.
 *
 * @param route_name
 * @param filters
 * @returns {Promise<NavigationFailure | void | undefined>}
 */
export async function setQueryParameters(route_name, filters) {
    return await router.push({
        name: route_name,
        query: filtersToQueryParameters(filters)
    });
}
